export default __webpack_public_path__ + "img/42cec652c75c79c4960ea0c60b7e16a4.svg";